import { createSlice } from "@reduxjs/toolkit"

export const vendorAddressListSlice = createSlice({
	name: "vendorAddress_list",
	initialState: {
		vendorAddress: "",
		errors: [],
	},

	reducers: {
        getVendorAddress: (state, action) => {
            // console.log(action.payload);
			state.vendorAddress = action.payload
		},
		getVendorAddressList: (state, action) => {
            
			state.vendorAddress = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getVendorAddress, getVendorAddressList, getErrors} = vendorAddressListSlice.actions

export default vendorAddressListSlice.reducer

